import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "@/pages/HomePage";
import LessonPage from "@/pages/LessonPage";
import JourneyPage from "@/pages/JourneyPage";
import LibraryPage from "@/pages/LibraryPage";
import AccessPage from "@/pages/AccessPage";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import { ThemeProvider } from "next-themes";

function App() {
  return (
    <div className="App">
      <ThemeProvider attribute="class" defaultTheme="dark" enableSystem={false}>
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/bibliotheque" element={<LibraryPage />} />
              <Route path="/parcours" element={<JourneyPage />} />
              <Route path="/entrer" element={<AccessPage />} />
              <Route path="/lecons/:slug" element={<LessonPage />} />
            </Routes>
          </BrowserRouter>
          <Toaster />
        </AuthProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;
